import { render, staticRenderFns } from "./PurchaseInvoiceBuffer.vue?vue&type=template&id=0944235a"
import script from "./PurchaseInvoiceBuffer.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceBuffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports